<script>
    /*
        CircularSpinner.svelte
    */

    import { onMount } from 'svelte';

    // TCARE components

    // SMUI components
    import CircularProgress from '@smui/circular-progress';

    const BG_PATH = 'img/tcare_symbol.png';

    export let delay;
    export let label;

    $: isShowing = false;
    
    onMount(() => {
        let timer = setTimeout(() => {
            clearTimeout(timer);
            isShowing = true;
        }, delay);
    })


</script>

<style>
    .circular-spinner {
        display: flex;
        flex-direction: column;
        align-items: center;
        color: var(--tcare-primary);
        /* border: 1px solid red; */
    }

    .circular-spinner p {
        font-size: 1em;
        font-weight: 100;
    }

    .circular-bg {
        position: absolute;
        width: 64px;
        height: 64px;
        display: flex;
        align-items: center;
        justify-content: center;
        /* background-color: green; */
    }

    /* the small centered TCARE logo */
    .circular-bg img {
        width: 26px;
        /* background-color: blue; */
    }

    /* the spinning outline */
    :global(.mdc-circular-progress svg) {
        stroke: var(--tcare-primary);
    }

    @media screen and (max-width: 600px) {
    }

    @media screen and (min-width: 601px) and (max-width: 1300px) {
    }

    @media screen and (min-width: 1201px) {
    }

</style>

{#if isShowing}
    <div class="circular-spinner">
        <div class="circular-bg"><img src={BG_PATH} alt={'TCARE Symbol'}></div>
        <CircularProgress style="height: 64px; width: 64px;" indeterminate />
        <p>{label}</p>
    </div>
{/if}